import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface DxfCheckboxProps extends CheckboxProps {
  name?: string;
  label?: string;
  control?: Control<any>;
}

function RawDxfCheckbox({ label, ...props }: DxfCheckboxProps) {
  return <FormControlLabel control={<Checkbox {...props} />} label={label} />;
}

export function DxfCheckbox({ name = "", label, control, ...props }: DxfCheckboxProps) {
  if (!control) return <RawDxfCheckbox label={label} {...props} />;
  return <Controller name={name} control={control} render={({ field }) => <RawDxfCheckbox checked={field.value} {...field} label={label} />} />;
}
